import { getApiErrorMessage } from "./api-error";

/** Backward-compatible message-only adapter for existing mutation hooks. */
export function toErrorMessage(error: unknown): string {
  return getApiErrorMessage(error, "The request could not be completed");
}
